import * as React from 'react';

import { createIcon } from '../Icon';
export const MousePointerIcon = createIcon(
  <React.Fragment>
    <path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z" />
    <path d="M13 13l6 6" />
  </React.Fragment>,
  'MousePointerIcon'
);
